const getNumberStyle = (sp) => {
  let numberStyle = undefined;
  if (sp === 'plivo') {
    numberStyle = {backgroundColor: 'rgba(34,197,94,0.2)', color: '#22c55e'};
  }
  else if (sp === 'twilio') {
    numberStyle = {backgroundColor: 'rgba(244,63,94,0.2)', color: '#f43f5e'};
  }
  else if (sp === 'avoxi') {
    numberStyle = {backgroundColor: 'rgba(245,158,11,0.2)', color: '#f59e0b'};
  }
  else if (sp === 'node-cc') {
    numberStyle = {backgroundColor: 'rgba(148,163,184,0.2)', color: '#94a3b8'};
  }
  else {
    numberStyle = {backgroundColor: 'rgba(59,130,246,0.2)', color: '#3b82f6'};
  }
  return numberStyle;
};

export default getNumberStyle;



// WEBPACK FOOTER //
// ./src/utils.js